import React, {Component}   from 'react';
import {
  Panel,
  Modal,
  Button
}                           from 'react-bootstrap';

import { IS_VALID }         from "utils";

import saveTrail            from '../../utils/saveTrail';

import CrudComponent        from './../zynappse-crud'
import
NotificationHistorySchema   from './NotificationHistorySchema'
import                           './style.less';
import FormContainer        from "./FormContainer";

class NotificationHistory extends Component {
  constructor (props) {
    super(props);

    this.renderModalButton = this.renderModalButton.bind(this);
  }

  renderModalButton () {

  }

  render() {
    let {
      NotificationHistory,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      formType,
      formTitle
    } = NotificationHistory;

    let {
			access
		} = accessjson;

    var notificationHistory = [
      { method: 'descending', column: 'createdAt'}
    ];

    let formContainerProps = {
      ...this.props
    };

    let crudProps = {
      schema: NotificationHistorySchema,
      moduleQuery: notificationHistory,
      access: access,
      saveTrail: saveTrail,
      customView: (obj) => {
        actions.setValue(
          {
            showModal: true,
            formType: "VIEW",
            formTitle: "VIEW NOTIFICATION HISTORY",
            formId: obj.id,
            selectedData: obj
          }
        );
      },
      customItems: [
        {
          columnName: "subject",
          render: ({ value }) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        }
      ]
    };

    return (
			<Panel>
				<Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>{NotificationHistorySchema.classNameLabel.toUpperCase()}</h4>
				</Panel.Heading>
				<Panel.Body>
					<CrudComponent {...crudProps}/>
				</Panel.Body>
        <Modal
          bsSize={null}
          show={showModal}
          onHide={() => {
            if (!isLoadingAction) {
              actions.setValue({ showModal: false });
            }
          }}
          >
          <Modal.Header closeButton>
            <Modal.Title>{(IS_VALID(formTitle) ? formTitle : formType).toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            {this.renderModalButton()}
          </Modal.Footer>
        </Modal>
			</Panel>
		);
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  NOTIFICATION_HISTORY
}                           from "actions/const";

function mapStateToProps(state) {
	let {
    NotificationHistory,
		accessjson
	} = state;

	return {
    NotificationHistory,
		accessjson
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObject, actionType = NOTIFICATION_HISTORY) => generics.setValue(actionType, keyValueObject)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(NotificationHistory);



// WEBPACK FOOTER //
// ./components/NotificationHistory/index.js